import React, { Component } from "react";
import "./Separator.css";

export class Separator extends Component {
  render() {
    return <div className="separator" />;
  }
}
